import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "settings"
const SettingsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.75 12Q18.749 11.371 18.635 10.767L18.561 10.367 20.358 8.658C20.035 7.852 19.598 7.103 19.066 6.431L17.082 7.017 16.692 7.132 16.382 6.868C15.76 6.335 15.039 5.914 14.252 5.635L13.867 5.5 13.77 5.104 13.286 3.092Q12.656 3.001 12 3 11.343 3 10.712 3.092L10.227 5.104 10.132 5.5 9.749 5.635C8.96 5.914 8.239 6.335 7.616 6.868L7.307 7.132 4.932 6.431C4.4 7.104 3.962 7.853 3.64 8.659L5.143 10.09 5.438 10.368 5.364 10.768Q5.251 11.37 5.25 12 5.252 12.629 5.364 13.231L5.438 13.631 5.143 13.911 3.64 15.339C3.962 16.145 4.4 16.894 4.931 17.567L6.916 16.981 7.306 16.865 7.617 17.132C8.162 17.597 8.782 17.978 9.456 18.253L9.75 18.364 10.132 18.5 10.227 18.895 10.712 20.907Q11.342 20.998 12 21 12.656 20.998 13.286 20.907L13.771 18.896 13.867 18.5 14.25 18.365C15.038 18.086 15.759 17.665 16.383 17.13L16.693 16.866 19.067 17.567C19.6 16.894 20.037 16.146 20.36 15.34L18.856 13.912 18.561 13.632 18.635 13.232Q18.748 12.628 18.75 12M14.25 12C14.25 10.757 13.243 9.75 12 9.75S9.75 10.757 9.75 12 10.757 14.25 12 14.25 14.25 13.243 14.25 12M15.75 12C15.75 14.071 14.071 15.75 12 15.75S8.25 14.071 8.25 12 9.929 8.25 12 8.25 15.75 9.929 15.75 12M20.25 12Q20.248 12.56 20.174 13.096L22.099 14.925 21.945 15.379C21.496 16.699 20.79 17.898 19.893 18.92L19.576 19.28 17.036 18.531C16.458 18.976 15.821 19.348 15.137 19.63L14.517 22.206 14.045 22.3C13.384 22.43 12.7 22.5 12 22.5S10.615 22.43 9.953 22.3L9.482 22.206 8.86 19.63C8.176 19.347 7.54 18.976 6.963 18.53L4.423 19.281 4.107 18.921C3.209 17.898 2.503 16.699 2.054 15.378L1.901 14.924 3.825 13.095Q3.75 12.559 3.75 12 3.75 11.44 3.825 10.904L1.9 9.075 2.054 8.621C2.504 7.301 3.21 6.101 4.107 5.077L4.424 4.717 6.964 5.468C7.54 5.022 8.177 4.65 8.86 4.37L9.482 1.793 9.952 1.699C10.617 1.57 11.3 1.5 12 1.5Q12.919 1.5 13.796 1.653L14.045 1.7 14.517 1.793 15.137 4.37C15.822 4.65 16.459 5.022 17.036 5.467L19.575 4.717 19.892 5.078C20.79 6.1 21.495 7.3 21.944 8.621L22.098 9.075 20.174 10.904C20.222 11.26 20.25 11.627 20.25 12" />
        </svg>
      }
    </span>
  )
}
export default SettingsIcon
